
export class PasswordCreator {
  private static readonly passwordNumeric: string = "1234567890";
  private static passwordUppercase: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  private static passwordLowercase: string = "abcdefghijklmnopqrstuvwxyz";
  private static passwordSymbol: string = '!"#$%&()=~|@[];:+-*<>?_>.,\'';

  static getPassword(): string {
    const length = 12;
    let password = '';
	  const passwordBase = (this.passwordNumeric + this.passwordUppercase + this.passwordLowercase + this.passwordSymbol);
	  for (let i = 0; i < length; i++) {
	  	password += passwordBase.charAt(Math.floor(Math.random() * passwordBase.length));
	  }
	  return password;
  }
}
